import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

class BaseRouteEvent {
  constructor(routeRenderContext) {
    _defineProperty(this, "routeRenderContext", void 0);
    this.routeRenderContext = routeRenderContext;
  }
}
export class UnmountRouteEvent extends BaseRouteEvent {
  constructor(routeRenderContext, routeChangeType, reactRoute) {
    super(routeRenderContext);
    _defineProperty(this, "reactRoute", void 0);
    _defineProperty(this, "routeChangeType", void 0);
    this.routeChangeType = routeChangeType;
    this.reactRoute = reactRoute;
  }
}
//# sourceMappingURL=RouteEvent.js.map
